import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/components/ui/FullDialog.js")